import React, { useState } from "react";
import {
  checkValue,
  errorMessageHandler,
  getHoursMinutesTime,
  getPersianDateObj,
} from "../../../constant/helper";
import AvatarPreview from "../../profile/components/AvatarPreview";
import { Link } from "react-router-dom";
import { message, Spin, Typography } from "antd";
import { ContractsAndJudicialDocumentsTypes, RootCategoriesTypes, SessionStatus } from "../../../constant/Types";
import { PushpinFilled, PushpinOutlined } from "@ant-design/icons";
import { pinSessionService, unpinSessionService } from "./../archive.api";
import MessageDateCategories from "../../chat/message/MessageDateCategories";

// import { Layer } from "react-map-gl";

const { Paragraph } = Typography;

const SessionItem = ({
  list,
  item,
  index,
  lawyer,
  client,
  status,
  baseOnTime,
  category,
  id,
  createdAt,
  pined,
  resetArchiveList,
  key,
}) => {
  const toPersian = getPersianDateObj(createdAt);
  const [loading, setLoading] = useState(false);
  const pinArchiveHandler = (e, pin) => {
    e.preventDefault();

    setLoading(true);

    (pin ? pinSessionService(id) : unpinSessionService(id))
      .then(async (res) => {
        message.success(`مشاوره ${pin ? `pin` : `unpin`} شد !`);

        setTimeout(async function () {
          resetArchiveList();
          setLoading(false);
        }, 1000);
      })
      .catch((e) => {
        setLoading(false);
        message.error(errorMessageHandler(e));
      });
  };

  return (
    <React.Fragment key={key}>
      <MessageDateCategories
        className={{
          textAlign: "center",
          color: "#656567",
          fontWeight: "400",
          fontSize: "14px",
          marginBottom: "1rem",
        }}
        messagesList={list}
        index={index}
        currentlyItem={item}
      />
      <Spin spinning={loading} delay={500}>
        <Link
          to={`/consultation/${
            checkValue(category) && checkValue(category.type)
              ? category.type
              : "rootType"
          }/${id}${baseOnTime ? "/baseOnTime" : ""}`}
          className={`archive-log ${
            status === "STARTED" || status === "READY_FOR_PAYMENT"
              ? "active"
              : "ended"
          }-archive-log center-flex`}
        >
          <div className="lawyer-section center-flex">
            <AvatarPreview
              isSvg={false}
              src={
                lawyer &&
                lawyer?.extraInfo &&
                lawyer?.extraInfo.hasOwnProperty("avatarImageUrl") &&
                lawyer?.extraInfo?.avatarImageUrl != null &&
                client?.extraInfo?.avatarImageUrl !== ""
                  ? lawyer?.extraInfo?.avatarImageUrl
                  : 4
              }
            />
            {item?.lawyerUnreadCount + item?.adminUnreadCount > 0 && (
              <div className="support-unread-message">
                {item?.lawyerUnreadCount + item?.adminUnreadCount}
              </div>
            )}

            <div className="info">
              {lawyer && (
                <div className="lawyer-name">
                  <LawyerDetail lawyer={lawyer} />
                </div>
              )}
              <div className="status">
                <div className="title">وضعیت مشاوره:</div>
                <div className="text">
                  <StatusMessage status={status} />
                </div>
              </div>
              <div className="status detail">
                <div className="title">نوع:</div>
                <Paragraph ellipsis className="text">
                  {`${{...RootCategoriesTypes, ...ContractsAndJudicialDocumentsTypes}[category.type].value}(${
                    item.categoryName
                  })`}
                </Paragraph>

                {!pined ? (
                  <PushpinOutlined
                    style={{
                      marginRight: "10px",
                      fontSize: "15px",
                    }}
                    onClick={(e) => {
                      pinArchiveHandler(e, true);
                    }}
                  />
                ) : (
                  <PushpinFilled
                    style={{
                      marginRight: "10px",
                      fontSize: "15px",
                    }}
                    onClick={(e) => {
                      pinArchiveHandler(e, false);
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          <div className="date-info">
            <div className="date">
              {toPersian
                ? `${toPersian.year}/${toPersian.month}/${toPersian.day}`
                : ""}
            </div>
            <div className="time">
              {getHoursMinutesTime(createdAt, "HH:mm")}
            </div>
          </div>
        </Link>
      </Spin>
    </React.Fragment>
  );
};

const LawyerDetail = ({ lawyer }) => {
  lawyer = lawyer.extraInfo;

  if (lawyer && checkValue(lawyer.fullName) && lawyer.fullName !== "") {
    return lawyer.fullName;
  } else if (
    lawyer &&
    checkValue(lawyer.firstName) &&
    lawyer.firstName !== "" &&
    lawyer &&
    checkValue(lawyer.lastName) &&
    lawyer.lastName !== ""
  ) {
    return lawyer.firstName + " " + lawyer.lastName;
  } else if (
    lawyer &&
    checkValue(lawyer.firstName) &&
    lawyer.firstName !== ""
  ) {
    return lawyer.firstName;
  } else if (lawyer && checkValue(lawyer.lastName) && lawyer.lastName !== "") {
    return lawyer.lastName;
  } else return "بدون نام";
};

const StatusMessage = ({ status = "" }) => {
  switch (status) {
    case SessionStatus.RECHARGE_NEEDED:
      return "نیاز به تمدید";
    case SessionStatus.CLOSED_BY_ADMIN:
      return "بسته شده توسط ادمین";
    case SessionStatus.STARTED:
      return "در حال انجام";
    case SessionStatus.READY_FOR_PAYMENT:
      return "آماده پرداخت";
    case SessionStatus.LOOKING_FOR_LAWYER:
      return "منتظر تائید وکیل";
    case SessionStatus.OPEN:
      return "باز  ";
    case SessionStatus.WAITING_FOR_CATEGORY:
      return "بدون دسته بندی  ";
    case SessionStatus.CLOSED:
      return "به اتمام رسیده";
    default:
      return "نامشخص";
  }
};

export default SessionItem;
